import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { getCommitHash } from 'sb-lib/env';
import { Store } from 'shared/store';
import { selectActiveUser } from 'shared/store/auth-slice';
import { SelfUser } from 'types/user';
import { getCurrentLoggingContext } from './logging-context';

const tracesSampleRate = parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE || '0.0');

export function initSentry(store: Store) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new TracingIntegrations.BrowserTracing()],
    tracesSampleRate,
    release: getCommitHash(),
    environment: process.env.SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tunnel: process.env.SENTRY_TUNNEL,
  });

  // build context from redux
  let prevUser: SelfUser | null = null;
  store.subscribe(() => {
    Sentry.setContext('realtime', getCurrentLoggingContext());
    const user = selectActiveUser(store.getState());
    if (user && prevUser !== user) {
      Sentry.setTag('org_id', user.org.id);
      Sentry.setUser({
        id: user.id.toString(),
        username: user.displayName,
        email: user.emailAddress,
      });
      prevUser = user;
    }
  });
}

export function getSentryReduxEnhancer() {
  return Sentry.createReduxEnhancer();
}
